<template>
  <div class="content" v-loading="loading">
    <el-button
      type="primary"
      @click="openEditWin('create')"
      >新增关联路灯</el-button
    >
    <el-table :data="tableData" style="width: 100%;margin-top:0;">
      <el-table-column
        prop="lamp_id"
        label="路灯ID"
        sortable
        align="center"
        fixed="left"
      ></el-table-column>
      <el-table-column
        prop="name"
        label="设备别名"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="number"
        label="设备识别号"
        align="center"
      ></el-table-column>
      <el-table-column prop="address" label="地址"></el-table-column>
      <el-table-column prop="edit" label="解绑" width="100">
        <template slot-scope="scope">
          <div class="edit-button">
            <i
              class="el-icon-link pointer"
              @click="delItem(scope.row.lamp_id)"
            ></i>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageInfo.page"
      :page-sizes="[10, 20, 30, 40, 50, 100]"
      :page-size="pageInfo.pageSize"
      layout="sizes, total, prev, pager, next, jumper"
      :total="cnt_all"
    >
    </el-pagination>

    <!--新增关联路灯-->
    <el-dialog
      class="dialog600"
      :title="'关联路灯'"
      :visible.sync="editOne.dialogVisible"
      v-if="editOne.dialogVisible"
      append-to-body
    >
      <el-form
        :model="editOne"
        label-position="left"
        label-width="140px"
      >
        <div class="user-info">
          <el-form-item label="选择路灯(可搜索)">
            <el-select
              clearable
              filterable
              placeholder="请选择路灯(可搜索)"
              v-model="editOne.lamp_id"
              style="width: 100%"
            >
              <el-option
                v-for="t in unBandLampList"
                :key="t.lamp_id"
                :label="t.number"
                :value="t.lamp_id"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="mw-edit-button" @click="editOne.dialogVisible = false"
          >取消</el-button
        >
        <el-button
          type="primary"
          @click="createItem"

          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import lightGroupApi from "@/api/light/lampGroup.js"
export default {
  name: "deviceList",
  props: {
    groupId: {
      type: Number,
    },
  },
  data() {
    return {
      loading: false,
      tableData: [],
      unBandLampList: [],
      pageInfo: {
        page: 1,
        pageSize: 40,
        lamp_group: this.groupId //灯组
      },
      cnt_all: 0,
      editOne: {
        lamp_id: '',
        number: '',
        dialogVisible: false
      },
    };
  },
  methods: {
    getTableData(pageIndex) {
      // 获取该分组下的所有路灯
      this.pageInfo.page = pageIndex;
      this.loading = true;
      lightGroupApi.getGroupLamps(this.pageInfo).then((res) => {
        if (res.data.code === 1000) {
          this.loading = false;
          let resData = res.data.data;
          this.tableData = resData.list;
          this.pageInfo.page = pageIndex;
          this.cnt_all = parseInt(resData.count);
          this.unBandLamps()
        }
      });
    },
    unBandLamps() {
      // 获取未绑定的所有路灯
      lightGroupApi.getUnassignedGroupLamps({
        page: 1,
        pageSize: 2000
      }).then((res) => {
        if (res.data.code === 1000) {
          let resData = res.data.data;
          this.unBandLampList = resData.list;
        }
      });
    },
    handleSizeChange(val) {
      this.pageInfo.pageSize = val;
      this.getTableData(this.pageInfo.page);
    },
    handleCurrentChange(val) {
      this.pageInfo.page = val;
      this.getTableData(this.pageInfo.page);
    },
    openEditWin() {
      this.editOne = {
        lamp_id: '',
        number: '',
        dialogVisible: true
      }
    },
    createItem() {
      if(!this.groupId){
        return this.$message.error('请选择路灯！');
      }
      if(!this.editOne.lamp_id){
        return this.$message.error('请选择路灯！');
      }
      lightGroupApi.gorupCommand(this.groupId, {
        lamp_id: this.editOne.lamp_id
      }).then((res) => {
        if (res.data.code === 1000) {
          this.$message.success(res.data.message);
          this.dialogVisible = false;
          this.getTableData(this.pageInfo.page);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    delItem(id) {
      this.$confirm("本操作将永久解绑该路灯，是否继续？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          lightGroupApi.gorupUntiecommand(id).then((res) => {
            if (res.data.code === 1000) {
              this.$message.success("解绑成功");
              this.getTableData(this.pageInfo.page);
            } else {
              this.$message.error(res.data.message);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消解绑",
          });
        });
    },
  },
  mounted() {
    this.getTableData(this.pageInfo.page);
  },
};
</script>
<style lang='less' scoped>
.content {
  width: 100%;
}
</style>
